import React, { useEffect, useRef, useMemo, useState } from "react";
import PressSectionCard from "./pressSectionCard";
import Tabs from "./tabs";
import { usePressroom } from "../../hooks/useCms";
import URI from "urijs";
import Pagination from "./pagination";
import { useHistory } from "react-router-dom";
import { slugToCountryPathname } from "../../utils/strings";

export default function PressroomCardsSection({ content }) {
  const history = useHistory();
  const searchObject = new URI().search(true);
  const newsContentRef = useRef();
  const tabs = content.tabs;
  const activeIndex = useMemo(() => Number(searchObject.tag || 0), [searchObject.tag]);
  const [pageChanged, setPageChanged] = useState(false);
  const { entries, pageCount } = usePressroom(tabs);

  useEffect(() => {
    if (newsContentRef.current && pageChanged) {
      window.scrollTo({ left: 0, top: newsContentRef.current.offsetTop - 100, behavior: "smooth" });
    }
  }, [entries, pageChanged, newsContentRef]);

  const buttonDetails = tabs.map((tab, i) => ({
    ...tab,
    classes: `secondary sm ${activeIndex === i ? "active" : ""}`
  }));

  const handleChangePage = selectedPage => {
    setPageChanged(true);
    history.replace(new URI(history.location).addSearch({ tag: searchObject.tag, page: selectedPage }).search());
  };

  const pressSectionCards = useMemo(
    () =>
      (entries || []).map(({ header: { h1, category = "", heroImage }, publicationDate, slug, link }, i) => (
        <PressSectionCard
          key={i}
          backgroundImage={heroImage?.formats?.small?.url || heroImage?.formats?.thumbnail?.url}
          category={category}
          headLine={h1}
          path={slugToCountryPathname(slug)}
          date={publicationDate}
          link={link || slug}
        />
      )),
    [entries]
  );

  return (
    <div className="container" id="pressroomCardsSection" ref={newsContentRef}>
      <Tabs flexDirection="row" buttonDetails={buttonDetails} activeIndex={activeIndex} />
      <div className="pressSectionCards">{pressSectionCards}</div>
      <Pagination onChange={handleChangePage} currentPage={Number(searchObject.page || 1)} totalPage={pageCount} />
    </div>
  );
}
